import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const tick = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/api/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
      } catch {}
      if (attempts < 30) setTimeout(tick, 2000);
      else setStatus("timeout");
    };
    tick();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-xl mx-auto px-5 lg:px-8 py-24 text-center" data-testid="payment-success">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="mx-auto text-neutral-500 animate-spin" />
            <h1 className="font-display text-3xl font-bold mt-6">Finalizing your subscription…</h1>
            <p className="text-neutral-600 mt-2">This typically takes 3–8 seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="h-16 w-16 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto"><CheckCircle2 size={32} /></div>
            <h1 className="font-display text-4xl font-bold mt-6">Welcome to Pro 🎉</h1>
            <p className="text-neutral-600 mt-2">AI document generation, deadline autopilot, and Academy are unlocked.</p>
            <Link to="/dashboard" className="btn-primary mt-8" data-testid="success-go-dashboard">Go to dashboard <ArrowRight size={16} /></Link>
          </>
        )}
        {status === "timeout" && (
          <>
            <h1 className="font-display text-3xl font-bold">Still processing</h1>
            <p className="text-neutral-600 mt-2">Payment providers can take a minute. Refresh, or head to your dashboard — we'll sync automatically.</p>
            <Link to="/dashboard" className="btn-primary mt-6">Go to dashboard</Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-display text-3xl font-bold">Missing session</h1>
            <p className="text-neutral-600 mt-2">We couldn't find your checkout session.</p>
            <Link to="/pricing" className="btn-primary mt-6">Back to pricing</Link>
          </>
        )}
      </div>
    </div>
  );
}
